const JobErrorCorrelativeType = {
  Text: 'text',
  LeadLink: 'leadlink'
}

export default JobErrorCorrelativeType
